import React from "react";
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import UserManagementActions from "../../Actions/UserManagementActions";
import UsermanagementConstants from "../../Constants/UsermanagementConstants";
import usermanagementStore from "../../Stores/UsermanagementStore";
import commonUtils from "../../helpers/commonUtils";
import { useLanguageContext } from "../../Context/LanguageContext";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";

const CloneOrganisation = (props) => {
  const { orgid, organisationName, cloneOrganisationSuccessCallback } = props;
  const [newOrganisationName, setNewOrganisationName] = useState("");
  const [adminName, setAdminName] = useState("");
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [subdomain, setSubdomain] = useState("");
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();

  const cloneOrganisation = (e) => {
    e.preventDefault();
    var data = {
      SourceOrganisationId: props.orgid,
      OrganisationName: newOrganisationName,
      AdminName: adminName,
      UserName: username,
      Email: email,
      SubDomain: subdomain,
    };
    setGlobalSpinner(true);
    UserManagementActions.cloneOrganisation(data);
  };

  useEffect(() => {
    function cloneOrganisationSuccess() {
      var res = usermanagementStore.getCloneOrgResult();
      resetFields();
      commonUtils.hideModalPopUp("cloneOrganisationModalClose");
      toast.success(localization.orgClonedSuccess);
      setGlobalSpinner(false);
      props.cloneOrganisationSuccessCallback();
    }

    function cloneOrganisationFailure() {
      var res = usermanagementStore.getCloneOrgResult();
      toast.error(res);
      setGlobalSpinner(false);
    }

    usermanagementStore.addChangeListener(
      UsermanagementConstants.CLONE_ORGANISATION_SUCCESS,
      cloneOrganisationSuccess
    );

    usermanagementStore.addChangeListener(
      UsermanagementConstants.CLONE_ORGANISATION_FAILURE,
      cloneOrganisationFailure
    );

    return () => {
      usermanagementStore.removeChangeListener(
        UsermanagementConstants.CLONE_ORGANISATION_SUCCESS,
        cloneOrganisationSuccess
      );

      usermanagementStore.removeChangeListener(
        UsermanagementConstants.CLONE_ORGANISATION_FAILURE,
        cloneOrganisationFailure
      );
    };
  }, []);

  const resetFields = () => {
    setNewOrganisationName("");
    setAdminName("");
    setUsername("");
    setEmail("");
    setSubdomain("");
  };

  return (
    <div
      className="modal fade"
      id="cloneOrganisationModal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="cloneOrganisationModal"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="cloneOrganisationModalTitle">
              {localization.cloneOrg} - {props.organisationName}
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              id="cloneOrganisationModalClose"
              onClick={resetFields}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <form
            id="cloneOrganisation"
            name="cloneOrganisation"
            onSubmit={cloneOrganisation}
          >
            <div className="modal-body">
              <div className="form-outline mb-4">
                <label className="form-label" htmlFor="organisationName">
                  {localization.organisation}
                </label>
                <input
                  type="text"
                  id="organisationName"
                  name="organisationName"
                  className="form-control"
                  placeholder={localization.organisationName}
                  required
                  value={newOrganisationName}
                  onChange={(e) => {
                    setNewOrganisationName(e.target.value);
                  }}
                />
              </div>
              <div className="form-outline mb-4">
                <label className="form-label" htmlFor="subdomain">
                  {localization.subDomain}
                </label>
                <input
                  type="text"
                  id="subdomain"
                  name="subdomain"
                  className="form-control"
                  placeholder={localization.subDomain}
                  required
                  value={subdomain}
                  onChange={(e) => {
                    setSubdomain(e.target.value);
                  }}
                />
              </div>
              <div className="form-outline mb-4">
                <label className="form-label" htmlFor="adminName">
                  {localization.adminName}
                </label>
                <input
                  type="text"
                  id="adminName"
                  name="adminName"
                  className="form-control"
                  placeholder={localization.enterAdminName}
                  required
                  value={adminName}
                  onChange={(e) => {
                    setAdminName(e.target.value);
                  }}
                />
              </div>

              <div className="form-outline mb-4">
                <label className="form-label" htmlFor="Username">
                  {localization.username}
                </label>
                <input
                  type="text"
                  id="Username"
                  className="form-control"
                  placeholder={localization.enterUsername}
                  required
                  value={username}
                  onChange={(e) => {
                    setUsername(e.target.value);
                  }}
                />
              </div>

              <div className="form-outline mb-4">
                <label className="form-label" htmlFor="email">
                  {localization.email}
                </label>
                <input
                  type="email"
                  id="email"
                  className="form-control"
                  placeholder={localization.enterEmail}
                  required
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                />
              </div>
            </div>
            <div className="modal-footer">
              <div className="form-group marProp ">
                <button
                  type="submit"
                  className="btn btn-primary btn-block mb-4"
                >
                  {localization.save}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CloneOrganisation;
